var map = {
	"./aa@2x.png": "60e9",
	"./bb@2x.png": "e13c",
	"./bg.jpg": "4fef",
	"./bgy.png": "f01e",
	"./bgy_grey.png": "0081",
	"./bl.png": "3952",
	"./bl_grey.png": "cce2",
	"./cc@2x.png": "2857",
	"./dd@2x.png": "0e5c",
	"./dy.png": "b2f2",
	"./dy_grey.png": "85ed",
	"./hr.png": "b7d7",
	"./hr_grey.png": "ac9b",
	"./jzy.png": "1e4b",
	"./jzy_grey.png": "febe",
	"./ld.png": "8e1c",
	"./ld_grey.png": "1791",
	"./map.png": "16c2",
	"./wd.png": "d3fd",
	"./wd_grey.png": "9b92",
	"./wk.png": "5077",
	"./wk_grey.png": "3fcd",
	"./xiajiantou.png": "efd1",
	"./xy.png": "e44b",
	"./xy_grey.png": "92f8",
	"./youjiantou-copy.png": "3861",
	"./yzf.png": "0269",
	"./yzf_grey.png": "e3e0",
	"./zs.png": "ad1e",
	"./zs_grey.png": "19171",
	"./zx.png": "a0dc",
	"./zx_grey.png": "3459"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "deff";